import {SUCCESS} from "../../../../constants/action-postfix";
import {GIA_REQUEST} from "../giaReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GIA_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};